import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const settingsHostStyleId = 'wb-v2-surface-settings-host-theme';

export const settingsHostBridgeStyles = {
  'wb-surface-settings-host': {
    '--local-settings-hit-weight': tokens.font.weight.semibold,
    '--local-settings-hit-line': tokens.componentColors.utility.purple400,
    '--local-settings-hit-line-width': tokens.borderWidth.md,
    '--local-settings-hit-line-offset': tokens.spacing.xxs,
    // A choice option's own description is secondary to the option label it sits under, so it drops a
    // step on the type scale. Shared wb-radio sizes both at textSm, which reads as two peer lines and
    // makes a disabled option's reason look like body copy rather than a hint.
    '--local-settings-option-hint-font-size': tokens.font.size.textXs,
    '--local-settings-option-hint-line-height': tokens.lineHeight.textXs,
    // Plain-row sections render their section-level messages here; same tokens as wb-section's box.
    '--local-settings-section-error-bg': tokens.color.background.errorPrimary,
    '--local-settings-section-error-border': tokens.color.border.errorSubtle,
    '--local-settings-section-error-radius': tokens.radius.sm,
  },
};

export function mountSettingsHostTheme(document: Document): void {

  DesignSystem.Mount(document, settingsHostStyleId, settingsHostBridgeStyles);
}
